// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyProfile_body__mFDDr {
  min-height: 100vh;
  display: flex;
}

.MyProfile_content__zmqhp {
  width: 67%;
}

.MyProfile_backHome__zVykG {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 40px 24px;
  gap: 20px;
  width: 100%;
  height: 108px;
  background: #fbfbfb;
  border-bottom: 1px solid #e9e9e9;
}

.MyProfile_backHomeText__Px6rR {
  width: 170px;
  height: 28px;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  align-items: center;
  color: #151515;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/views/MyProfile/MyProfile.module.scss"],"names":[],"mappings":"AAKA;EACE,iBAAA;EACA,aAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAJF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n$sidebar-width: 33%;\n\n.body {\n  min-height: 100vh;\n  display: flex;\n}\n\n.content {\n  width: 100% - $sidebar-width;\n}\n\n.backHome {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 40px 24px;\n  gap: 20px;\n  width: 100%;\n  height: 108px;\n  background: #fbfbfb;\n  border-bottom: 1px solid #e9e9e9;\n}\n\n.backHomeText {\n  width: 170px;\n  height: 28px;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  display: flex;\n  align-items: center;\n  color: #151515;\n  cursor: pointer;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `MyProfile_body__mFDDr`,
	"content": `MyProfile_content__zmqhp`,
	"backHome": `MyProfile_backHome__zVykG`,
	"backHomeText": `MyProfile_backHomeText__Px6rR`
};
export default ___CSS_LOADER_EXPORT___;
